import { api } from 'app/utils/api/helpers'

export const sendDepositReceivedNoticeToOwner = (teamGUID, payload) => {
  return api.post(`/sm/teams/${teamGUID}/depositreceivedowner`, payload)
}
